type ErrorObject = {
	message: string;
	title: string;
	variant: string;
};

export type ErrorType = keyof typeof ErrorEnum;

export const ErrorEnum = {
	RELATION_NO_MEMBER_NOTIFICATION: {
		message:
			'Je bent een relatie van de ANWB, maar je hebt nog geen ANWB lidmaatschap. Voor € 17,- per jaar krijg je een ANWB lidmaatschap.',
		title: 'ANWB Lidmaatschap',
		variant: 'info',
	} as ErrorObject,
	MISSING_FIELDS_ERROR: {
		message: '',
		title: 'Niet alle velden zijn correct ingevuld',
		variant: 'error',
	} as ErrorObject,
	RETRIEVING_DATA_LOGGED_IN_ERROR: {
		message:
			'Je bent ingelogd, maar je gegevens konden niet worden opgehaald. Ververs de pagina, of sluit dit tabblad en probeer het later opnieuw.',
		title: 'Er is helaas iets misgegaan',
		variant: 'error',
	} as ErrorObject,
};
